let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("98b3U")).then(() => parcelRequire('iyTU3'));